var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v("群組保護")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("成員名單設定")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("成員名單設定")]), _c('div', {
    staticClass: "row d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4 d-flex align-items-center flex-nowrap my-3"
  }, [_c('h6', {
    staticClass: "mb-xl-0 font-weight-bold text-nowrap mr-2"
  }, [_vm._v("群組")]), _c('b-form-select', {
    attrs: {
      "options": _vm.groups.map(function (x) {
        return {
          text: "".concat(x.branch_code, " ").concat(x.name),
          value: x.id
        };
      })
    },
    on: {
      "change": _vm.fetchCustomers
    },
    scopedSlots: _vm._u([_vm.groups.length != 1 ? {
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": ""
          }
        }, [_vm._v("-- 請選擇 --")])];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.currentGroup,
      callback: function callback($$v) {
        _vm.currentGroup = $$v;
      },
      expression: "currentGroup"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-4 d-flex my-3 align-items-center"
  }, [_c('h6', {
    staticClass: "mb-2 mr-2 mb-xl-0 font-weight-bold flex-shrink-0"
  }, [_vm._v(" 角色 ")]), _c('AppMultiSelect', {
    attrs: {
      "options": _vm.roleOptions
    },
    on: {
      "input": _vm.fetchCustomers
    },
    model: {
      value: _vm.selectedRoles,
      callback: function callback($$v) {
        _vm.selectedRoles = $$v;
      },
      expression: "selectedRoles"
    }
  })], 1), _c('div', {
    staticClass: "\n            col-12 col-xl-4\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center\n            my-3\n          "
  }, [_c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋姓名/平台ID"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchCustomers.apply(null, arguments);
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.fetchCustomers
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "col-12 col-xl-4 d-flex align-items-center flex-nowrap my-3"
  }, [_c('h6', {
    staticClass: "mb-xl-0 font-weight-bold text-nowrap mr-2"
  }, [_vm._v("設定角色")]), _c('b-form-select', {
    attrs: {
      "options": _vm.roleOptions.filter(function (x) {
        return x.value != 'guard';
      })
    },
    model: {
      value: _vm.setRole,
      callback: function callback($$v) {
        _vm.setRole = $$v;
      },
      expression: "setRole"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("-請選擇角色-")])], 1), _c('b-button', {
    staticClass: "ml-2 text-nowrap",
    attrs: {
      "variant": "primary",
      "disabled": _vm.setRole == null || _vm.selectedCustomers.length == 0
    },
    on: {
      "click": _vm.setRoleToCustomers
    }
  }, [_vm._v("設定")])], 1)]), _c('hr'), _c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "店內成員",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("群組人數：" + _vm._s(_vm.customers.length))]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.customers,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(id)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.id,
            "disabled": data.item.role == 'black_global' || data.item.role == 'guard'
          },
          model: {
            value: _vm.selectedCustomers,
            callback: function callback($$v) {
              _vm.selectedCustomers = $$v;
            },
            expression: "selectedCustomers"
          }
        })];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.name) + " ")];
      }
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.avatar_url,
            expression: "!!data.item.avatar_url"
          }],
          staticClass: "rounded-circle",
          attrs: {
            "src": data.item.avatar_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))];
      }
    }, {
      key: "cell(role)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.roleEnum(data.item.role).variant
          }
        }, [_vm._v(_vm._s(_vm.roleEnum(data.item.role).text))])];
      }
    }])
  })], 1), _c('b-tab', {
    attrs: {
      "title": "廣告黑名單（全店）"
    }
  }, [_c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.globalBlackCustomers,
      "fields": _vm.blackFields
    },
    scopedSlots: _vm._u([{
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('b-img-lazy', _vm._b({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !!data.item.avatar_url,
            expression: "!!data.item.avatar_url"
          }],
          staticClass: "rounded-circle",
          attrs: {
            "src": data.item.avatar_url
          }
        }, 'b-img-lazy', _vm.mainProps, false))];
      }
    }, {
      key: "cell(role)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.roleEnum(data.item.role).variant
          }
        }, [_vm._v(_vm._s(_vm.roleEnum(data.item.role).text))])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }